/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { BuilderUserContext } from '@gh/builder-shared';
import { CommunicationRestService, UserRestService } from '@gh/builder-shared-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { SlicedDataSource } from '@gh/core-data';
import { ActivatedRouteSnapshot } from '@angular/router';
import { InitViewService } from '@gh/common-shared';
import { Observable } from 'rxjs';

@Injectable()
export class SmsListBusinessService implements InitViewService {

  constructor(
    private gridLayoutService: GridLayoutService,
    private communicationRest: CommunicationRestService,
    private userRest: UserRestService,
    private builderUserContext: BuilderUserContext) {

  }

  initView(route: ActivatedRouteSnapshot): any {
    return {
      gridLayout: this.gridLayoutService.get('messages'),
    };
  }

  findAllAsDataSource(filter: any): SlicedDataSource<any> {
    return this.communicationRest.getSmsList(filter);
  }

  markAsRead(filter: any): Observable<any> {
    return this.communicationRest.markMessagesReadOrUnread(filter);
  }
}
